import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["emergency-roof-repair"];

export const Route = createFileRoute("/services/emergency-roof-repair")({
  head: () => ({
    meta: [
      { title: "Emergency Roof Repair Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Fast emergency roof repair in Southern California for active leaks, storm damage and failed roofs. Local crew, honest work." },
      { property: "og:title", content: "Emergency Roof Repair – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/emergency-roof-repair" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});